type MinimalTagDetails = {
  tagId: string | number
  urlPath?: string
  name: string
}

export const getHrefFromTag = ({tagId, urlPath, name}: MinimalTagDetails) => {
  return `${encodeURIComponent(urlPath || sanitizeNameToLink(name))}/${tagId}`
}

export const sanitizeNameToLink = (name: string) => {
  return name.toLowerCase().trim().replace(/\s+/g, '-')
}
